var map = {
	"./banner/20191117.jpg": 1453,
	"./change_01.jpg": 1454,
	"./change_02.jpg": 1455,
	"./change_03.jpg": 1456,
	"./change_04.jpg": 1457,
	"./change_05.jpg": 1458,
	"./chinese_01.jpg": 1459,
	"./chinese_02.jpg": 1460,
	"./chinese_03.jpg": 1461,
	"./chinese_04.jpg": 1462,
	"./chinese_05.jpg": 1463,
	"./cn/chinese_01.jpg": 1464,
	"./cn/chinese_02.jpg": 1465,
	"./cn/chinese_03.jpg": 1466,
	"./cn/chinese_04.jpg": 1467,
	"./cn/chinese_05.jpg": 1468,
	"./cn/course_01.jpg": 1469,
	"./cn/course_02.jpg": 1470,
	"./cn/course_03.jpg": 1471,
	"./cn/course_04.jpg": 1472,
	"./cn/course_05.jpg": 1473,
	"./cn/explore_01.jpg": 1474,
	"./cn/explore_02.jpg": 1475,
	"./cn/explore_03.jpg": 1476,
	"./cn/explore_04.jpg": 1477,
	"./cn/explore_05.jpg": 1478,
	"./cn/festival_01.jpg": 1479,
	"./cn/festival_02.jpg": 1480,
	"./cn/festival_03.jpg": 1481,
	"./cn/festival_04.jpg": 1482,
	"./cn/festival_05.jpg": 1483,
	"./cn/phonics_01.jpg": 1484,
	"./cn/phonics_02.jpg": 1485,
	"./cn/phonics_03.jpg": 1486,
	"./cn/phonics_04.jpg": 1487,
	"./course_01.jpg": 1488,
	"./course_02.jpg": 1489,
	"./course_03.jpg": 1490,
	"./course_04.jpg": 1491,
	"./course_05.jpg": 1492,
	"./en/change_01.jpg": 1493,
	"./en/change_02.jpg": 1494,
	"./en/change_03.jpg": 1495,
	"./en/change_04.jpg": 1496,
	"./en/change_05.jpg": 1497,
	"./en/chinese_01.jpg": 1498,
	"./en/chinese_02.jpg": 1499,
	"./en/chinese_03.jpg": 1500,
	"./en/chinese_04.jpg": 1501,
	"./en/chinese_05.jpg": 1502,
	"./en/course_01.jpg": 1503,
	"./en/course_02.jpg": 1504,
	"./en/course_03.jpg": 1505,
	"./en/course_04.jpg": 1506,
	"./en/course_05.jpg": 1507,
	"./en/explore_01.jpg": 1508,
	"./en/explore_02.jpg": 1509,
	"./en/explore_03.jpg": 1510,
	"./en/explore_04.jpg": 1511,
	"./en/explore_05.jpg": 1512,
	"./en/festival_01.jpg": 1513,
	"./en/festival_02.jpg": 1514,
	"./en/festival_03.jpg": 1515,
	"./en/festival_04.jpg": 1516,
	"./en/festival_05.jpg": 1517,
	"./en/phonics_01.jpg": 1518,
	"./en/phonics_02.jpg": 1519,
	"./en/phonics_03.jpg": 1520,
	"./en/phonics_04.jpg": 1521,
	"./en/story_01.jpg": 1522,
	"./en/story_02.jpg": 1523,
	"./en/story_03.jpg": 1524,
	"./en/story_04.jpg": 1525,
	"./en/story_05.jpg": 1526,
	"./explore_01.jpg": 1527,
	"./explore_02.jpg": 1528,
	"./explore_03.jpg": 1529,
	"./explore_04.jpg": 1530,
	"./explore_05.jpg": 1531,
	"./festival_01.jpg": 1532,
	"./festival_02.jpg": 1533,
	"./festival_03.jpg": 1534,
	"./festival_04.jpg": 1535,
	"./festival_05.jpg": 1536,
	"./phonics_01.jpg": 1537,
	"./phonics_02.jpg": 1538,
	"./phonics_03.jpg": 1539,
	"./phonics_04.jpg": 1540,
	"./story_01.jpg": 1541,
	"./story_02.jpg": 1542,
	"./story_03.jpg": 1543,
	"./story_04.jpg": 1544,
	"./story_05.jpg": 1545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2541;